<template>
  <a-drawer
    title="结算明细"
    width="1000"
    :visible="visible"
    :closable="false"
    @close="onClose"
  >
    <!-- 功能条 -->
    <div class="tool-view">
      <!-- 信息 -->
      <span class="hint-info">共选择了<span class="hint-desc">{{ dataSource.length }}</span>天数据，总计分成金额<span class="hint-desc">{{ $pub.KEEP_NUMBER_DECIMAL(totalCashAmount / 100, 2, false, true) }}</span>元。</span>
      <!-- 弹簧 -->
      <div style="flex: 1;"></div>
      <!-- 操作 -->
      <a-button @click="touchDownload">导出数据</a-button>
    </div>
    <!-- 列表 -->
    <a-table
      class="table-view"
      bordered
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="false"
      @change="handleTableChange"
    >
      <!-- 自定义行内容 -->
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'wx_cpm_cash_amount' || column.key === 'total_cash_amount' || column.key === 'total_cash_amount'">
          {{ record[column.key] == 0 ? '-' : $pub.KEEP_NUMBER_DECIMAL((record[column.key] || 0) / 100, 2, false, true) }}
        </template>
        <template v-else>
          {{ record[column.key] || '-' }}
        </template>
      </template>
    </a-table>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import * as Ex from "@netjoy/excelex"
import { cpmResellerCashDayDetail } from '@/api/copyright'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'

// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 当前数据
let data = ref({})
// 数据源
let dataSource = ref([])
// 总分成金额
let totalCashAmount = ref(0)
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '日期',
    dataIndex: 'data_date',
    key: 'data_date'
  },
  {
    title: '微小广告次数',
    dataIndex: 'wx_ad_count',
    key: 'wx_ad_count'
  },
  {
    title: '微小广告分成',
    dataIndex: 'wx_cpm_cash_amount',
    key: 'wx_cpm_cash_amount'
  },
  {
    title: '抖小广告次数',
    dataIndex: 'dy_ad_count',
    key: 'dy_ad_count'
  },
  {
    title: '抖小广告分成',
    dataIndex: 'dy_cpm_cash_amount',
    key: 'dy_cpm_cash_amount'
  },
  {
    title: '总计分成金额',
    dataIndex: 'total_cash_amount',
    key: 'total_cash_amount'
  }
])

// 显示
function showDrawer (record) {
  // 清空
  totalCashAmount.value = record.cash_amount
  dataSource.value = []
  // 记录
  data.value = record
  // 显示
  visible.value = true
  // 获取数据详情列表
  getList()
}

// 关闭
function onClose () {
  if (!isLoading.value) {
    pagination.current = 1
    visible.value = false
  }
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 获取数据详情列表
function getList () {
  isLoading.value = true
  const params = {
    id: data.value.id
  }
  cpmResellerCashDayDetail(params).then(res => {
    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      dataSource.value = data
    } else {
      message.error(res.message || msg)
    }
  })
}

// 点击导出数据
function touchDownload () {
  if (dataSource.value.length) {
    const columns = [
      {
        name: '日期',
        field: 'data_date'
      },
      {
        name: '微小广告次数',
        field: 'wx_ad_count'
      },
      {
        name: '微小广告分成',
        field: 'wx_cpm_cash_amount'
      },
      {
        name: '抖小广告次数',
        field: 'dy_ad_count'
      },
      {
        name: '抖小广告分成',
        field: 'dy_cpm_cash_amount'
      },
      {
        name: '总计分成金额',
        field: 'total_cash_amount'
      }
    ]
    const sheets = [
      {
        data: dataSource.value,
        columns: columns
      }
    ]
    Ex.ex(sheets, function (item, field, json, sheetIndex, row, col, rowCount, colCount) {
      // row=0 为表头
      if (row != 0) {
        if (field === 'wx_cpm_cash_amount' || field === 'total_cash_amount' || field === 'total_cash_amount') {
          item.data = json[field] == 0 ? '-' : Pub.KEEP_NUMBER_DECIMAL(item.data / 100, 2, false, true)
          return item
        }
      }
      // 无数据兼容
      item.data = item.data || '-'
      return item
    },  `结算明细-CPM金额`)
  } else {
    message.error('还没有可导出的内容')
  }
}

// 抛出
defineExpose({
  showDrawer
})

</script>

<style scoped>
.tool-view {
  width: 100%;
  display: flex;
  align-items: center;
}
.table-view {
  margin-top: 30px;
}

.hint-info {
  color: #A7A7A7;
}
.hint-desc {
  color: #323232;
}
</style>